import { render, staticRenderFns } from "./index.vue?vue&type=template&id=192d3097&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=192d3097&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192d3097",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('192d3097')) {
      api.createRecord('192d3097', component.options)
    } else {
      api.reload('192d3097', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=192d3097&scoped=true", function () {
      api.rerender('192d3097', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/index.vue"
export default component.exports